import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface commodityPageParams {
  current?: number;
  size?: number;
  allMaterials?: number;
  allStr?: string;
  materialsCategory?: number;
  otc?: number;
  state: number;
  tenantSupplierId?: number;
  flag?: number;
}

export interface linkangParams {
  current?: number;
  materialsCategory?: number;
  size?: number;
  name?: string;
}

export interface commoditySubmitBody {
  accountUnit?: string | undefined;
  antibioticTag?: number | undefined;
  approvalNumber?: string | undefined;
  barCode?: string | undefined;
  basicMedicineTag?: number | undefined;
  billingCategory?: string | undefined;
  compoundTag?: number | undefined;
  doseCategory?: string | undefined;
  doseUnit?: string | undefined;
  drugCategory?: string | undefined;
  ephedrineTag?: number | undefined;
  freezeTemperature?: string | undefined;
  genericName?: string | undefined;
  id?: number | undefined;
  inventoryAlert?: number | undefined;
  materialsCategory?: number | undefined;
  miscNo?: string | undefined;
  mnemonicCode?: string | undefined;
  name?: string | undefined;
  no?: string | undefined;
  normalDose?: number | undefined;
  normalFrequency?: string | undefined;
  normalUsemethod?: string | undefined;
  orderCategory?: number | undefined;
  origin?: string | undefined;
  otc?: number | undefined;
  packSpec?: string | undefined;
  productionLicence?: string | undefined;
  reportNo?: string | undefined;
  retailPrice?: number | undefined;
  skinTestTag?: number | undefined;
  sourceMaterialsCatalogId?: number | undefined;
  spec?: string | undefined;
  splitPrice?: number | undefined;
  splitScale?: number | undefined;
  splitTag?: number | undefined;
  splitUnit?: string | undefined;
  state?: number | undefined;
  stimulantTag?: number | undefined;
  stockPrice?: number | undefined;
  tenantId?: number | undefined;
  tenantSupplierId?: number | undefined;
  tradeRemark?: string | undefined;
  transitionScale?: number | undefined;
  useDays?: string | undefined;
  tenantSupplierName?: string | undefined;
}

export interface logoutOrEnableBody {
  ids: string;
  state: number;
}

//分页
export function commodityPage(params: commodityPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/page`,
    method: "GET",
    params,
  };
}

//启用
export function commoditylogoutOrEnable(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/logoutOrEnable`,
    method: "post",
    params: {
      id,
    },
  };
}

//新增
export function commoditySave(body: commoditySubmitBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/submit`,
    method: "POST",
    body,
  };
}

//详情
export function commodityDetail(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/detail`,
    method: "GET",
    params: {
      id,
    },
  };
}

//麟康药品库
export function getLinKangdurgstore(params: linkangParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/list`,
    method: "GET",
    params,
  };
}

//导入标准药品
export function saveLinkangDurg(ids: string): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/importbatch`,
    method: "POST",
    params: {
      ids,
    },
  };
}

//商品编码
export function getGoodsNo(): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/seq/allocate/GoodsNo`,
    method: "POST",
  };
}

//诊疗编码
export function getServiceNo(): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/seq/allocate/TreatmentServiceNo`,
    method: "POST",
  };
}

export function commodityLogoutOrEnableList(body: logoutOrEnableBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/logoutbatch`,
    method: "POST",
    body,
  };
}
